import React from 'react';
import { createRoot } from 'react-dom/client';

import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';

import App from './App';
import AppStateProvider, { useAppState } from './state';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
//import LoginPage from './components/LoginPage/LoginPage';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import './types';

import { VideoProvider } from './components/VideoProvider';
import useConnectionOptions from './utils/useConnectionOptions/useConnectionOptions';
import UnsupportedBrowserWarning from './components/UnsupportedBrowserWarning/UnsupportedBrowserWarning';

const VideoApp = () => {
  const { error, setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  return (
    <UnsupportedBrowserWarning>
      <VideoProvider options={connectionOptions} onError={setError}>
        <ErrorDialog dismissError={() => setError(null)} error={error} />
        <App />
      </VideoProvider>
    </UnsupportedBrowserWarning>
  );
};

createRoot(document.getElementById('root')!).render(
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <AppStateProvider>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <VideoApp />
              </PrivateRoute>
            }
          />
          <Route
            path="/room/:URLRoomName"
            element={
              <PrivateRoute>
                <VideoApp />
              </PrivateRoute>
            }
          />
          {/* <LoginPage /> is not used: the app is opened with a signed link. */}
          <Route path="/login" element={<VideoApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppStateProvider>
    </Router>
  </MuiThemeProvider>
);
